import { ADMIN_TOKEN_KEY } from '../../lib/api';

export const JURISDICTION_FLAGS = {
  jamaica: '🇯🇲',
  barbados: '🇧🇧',
  bermuda: '🇧🇲',
  cayman: '🇰🇾',
  bahamas: '🇧🇸',
  belize: '🇧🇿',
  grenada: '🇬🇩',
};

export const STATUS_COLORS = {
  new: 'bg-slate-500/10 text-slate-400 border-slate-500',
  contacted: 'bg-blue-500/10 text-blue-400 border-blue-500',
  lead: 'bg-yellow-500/10 text-yellow-400 border-yellow-500',
  client: 'bg-green-500/10 text-green-400 border-green-500',
};

export const STATUS_LABELS = {
  new: 'New',
  contacted: 'Contacted',
  lead: 'Lead',
  client: 'Client',
};

export const getAdminToken = () =>
  sessionStorage.getItem(ADMIN_TOKEN_KEY) || localStorage.getItem('adminToken');

export const clearAdminToken = () => {
  sessionStorage.removeItem(ADMIN_TOKEN_KEY);
  localStorage.removeItem('adminToken');
};

export const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getScoreColor = (level) => {
  switch (level) {
    case 'high': return 'bg-[#10B981]/10 text-[#10B981]';
    case 'medium': return 'bg-[#F59E0B]/10 text-[#F59E0B]';
    case 'low': return 'bg-[#EF4444]/10 text-[#EF4444]';
    default: return 'bg-slate-100 text-slate-600';
  }
};

export const getScoreLevel = (percentage) => {
  if (percentage >= 80) return 'high';
  if (percentage >= 50) return 'medium';
  return 'low';
};

export const getInvitationStatusColor = (status) => {
  switch (status) {
    case 'completed': return 'bg-[#10B981]/10 text-[#10B981] border-[#10B981]';
    case 'started': return 'bg-[#F59E0B]/10 text-[#F59E0B] border-[#F59E0B]';
    case 'pending':
    default:
      return 'bg-slate-500/10 text-slate-400 border-slate-500';
  }
};
